import { useApplication } from "@certn/application";
import { NavLogo } from "@certn/cascadia-react/components/navigation/navigation-top/NavLogo";

import { Branding } from "./types";

interface Props {
  type?: "logo" | "full";
  branding?: Branding;
}

export function AppLogo(props: Props) {
  const { branding: contextBranding } = useApplication();

  // Use props.branding if provided, otherwise fall back to context branding
  const branding = props.branding ?? contextBranding;

  return (
    <NavLogo
      logoUrl={branding?.logo_url}
      darkLogoUrl={branding?.org_logo_url_dark_mode}
      orgIconUrl={branding?.org_icon_url}
      orgIconUrlDarkMode={branding?.org_icon_url_dark_mode}
      type={props.type}
    />
  );
}
